type GameDataOf = { [id: string]: {memoOf: MemoOf} }
type MemoOf = { [id: string]: string }

interface RoomStorageData {
  roomMemberId: string;
  gameDataOf: GameDataOf;
}

export class RoomStorage {
  private roomId: string;
  private data: RoomStorageData;

  constructor (roomId: string) {
    this.roomId = roomId
    this.data = this.fetchData()
  }

  private get roomItemName () {
    return `roomData-${this.roomId}`
  }

  private fetchData() {
    const roomItem = localStorage.getItem(this.roomItemName)
    if (roomItem) {
      return JSON.parse(roomItem)
    }

    const emptyData = {
      roomMemberId: '',
      gameDataOf: {},
    }

    return emptyData
  }

  public get roomMemberId () {
    return this.data.roomMemberId
  }

  public get gameDataOf () {
    return this.data.gameDataOf
  }

  public saveRoomMemberId (roomMemberId: string) {
    const data = this.fetchData()
    data.roomMemberId = roomMemberId
    localStorage.setItem(this.roomItemName, JSON.stringify(data))
    this.data = data
  }

  public saveMemo (gameId: string, playerId: string, memo: string) {
    const data = this.fetchData()
    
    if (!data.gameDataOf[gameId]) {
      data.gameDataOf[gameId] = {
        memoOf: {}
      }
    }

    data.gameDataOf[gameId].memoOf[playerId] = memo
    localStorage.setItem(this.roomItemName, JSON.stringify(data))
    this.data = data
  }

  public removeData () {
    localStorage.removeItem(this.roomItemName)
  }
}
